// import { canUseDOM } from 'exenv';

export function searchPageLoading(resp = {}, store = {}) {
  return {
    type: 'SEARCH_PAGE_LOADING',
    searchPage: resp,
    store
  };
}

export function searchPageLoaded(resp = {}, store = {}) {
  return {
    type: 'SEARCH_PAGE_LOADED',
    searchPage: resp,
    store
  };
}

export function searchPageLoadError(error, store = {}) {
  return {
    type: 'SEARCH_PAGE_ERROR',
    searchPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
